import React from 'react';
import { Users, Clock, CheckCircle, DollarSign } from 'lucide-react';

const stats_config = [
  { key: 'customers', label: 'MUSTERI',       icon: Users,       color: '#06b6d4', getValue: (s) => s.totalCustomers },
  { key: 'active',    label: 'AKTIF IS',      icon: Clock,       color: '#F97316', getValue: (s, ds) => ds?.active ?? s.activeJobs },
  { key: 'ready',     label: 'TESLIME HAZIR', icon: CheckCircle, color: '#10b981', getValue: (s, ds) => ds?.readyWaiting ?? s.readyJobs },
  { key: 'collected', label: 'TAHSILAT',      icon: DollarSign,  color: '#10b981', getValue: (s) => s.totalCollected, unit: 'TL', format: true },
  { key: 'remaining', label: 'BEKLEYEN',      icon: DollarSign,  color: '#F97316', getValue: (s) => s.totalRemaining, unit: 'TL', format: true },
];

const DashboardStatsRow = ({ stats, dashboardStats }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-10" data-testid="stats-row">
      {stats_config.map((cfg, i) => {
        const Icon = cfg.icon;
        const rawVal = cfg.getValue(stats, dashboardStats);
        const displayVal = cfg.format ? Number(rawVal).toLocaleString('tr-TR') : rawVal;
        return (
          <div key={cfg.key} className="card-premium rounded-2xl p-5 fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="flex items-center justify-between mb-4">
              <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground">
                {cfg.label}
              </span>
              <div
                className="w-7 h-7 rounded-md flex items-center justify-center"
                style={{ background: `${cfg.color}1a`, color: cfg.color }}
              >
                <Icon size={14} />
              </div>
            </div>
            <div className="flex items-baseline gap-1">
              <div className="font-mono font-semibold text-[26px] leading-none">{displayVal}</div>
              {cfg.unit && <span className="font-mono text-sm text-muted-foreground">{cfg.unit}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DashboardStatsRow;
